import { createSlice } from '@reduxjs/toolkit'

export const WizardMode = Object.freeze({
    NewUser: 'new-user',
    UpgradePlan: 'upgrade-plan',
})

const initialState = {
    mode: null,
    returnURL: null,
    userType: null,
    steps: [],
    currentStep: null,
}

const wizardSlice = createSlice({
    name: 'wizard',
    initialState,
    reducers: {
        initializeWizard(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },
        beginStep(state, action) {
            const step = state.steps.find(({ id }) => id === action.payload)
            step.done = false
            state.currentStep = action.payload
        },
        completeStep(state, action) {
            const step = state.steps.find(({ id }) => id === action.payload)
            step.done = true
        },
    },
})

const { initializeWizard, beginStep, completeStep } = wizardSlice.actions

export const wizardActions = {
    initializeWizard,
    beginStep,
    completeStep,
}

export const wizardSelectors = {
    wizardState: state => state.wizard,
}

export default wizardSlice.reducer
